// extracted by mini-css-extract-plugin
export default {"fullPageWrapper":"FullPageWrapper-module__fullPageWrapper--Zz26H"};